/** Which kind of AI Chat asset a publish run is materialising. Mirrors the PHP AiChatAssetKind enum. */
export enum AiChatAssetKind {
  IMAGE = 'image',
  ANIMATION = 'animation',
}
